import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ROUTES } from "../../routes/routeKeys";
import { NotificationManager } from "react-notifications";
import axios from "axios";
import moment from 'moment';
import useAuth from "../../hooks/useAuth";
import Loader from "../../components/Loader";
import { BASE_URL } from "../../utils/Element";
import BaseLayout from "../../layouts/BaseLayout";
import AddPropertyData from "./components/AddPropertyData";

const initialPropertyInfo = {
  propertyName: "",
  storeNumber: "",
  propertyType: "",
  streetAddress: "",
  city: "",
  state: "",
  zipcode: "",
  googleMapsLink: "",
  rprLink: "",
  lastUpdateDate: "",
  comment: "",
  leaseType: null,
  leaseCommencementDate: "",
  leaseExpirationDate: "",
  annualRent: "",
  askingCapRate: "",
  askingPrice: "",
  buildingSize: "",
  landSize: "",
  availabilityStatusUpdateDate: "",
  owner_name: "",
  owner_id: "",
  ownerType: "company",
  year_built:"",
  year_renovated:"",
  guarantor_options:"",
  propertyTag: [],
};

const EditProperty = () => {
  const [config] = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(true);
  const [propertyInfo, setPropertyInfo] = useState(initialPropertyInfo);

  const propertydetailsdata = () => {
    setLoading(true);
    console.log("Fetching property details for ID:", id);
    axios
      .get(`${BASE_URL}/property-getbyid/${id}`, config)
      .then((res) => {
        console.log("Response from API:", res);
        const propertyEditdata = res?.data?.data;
        setPropertyInfo({
          propertyName: propertyEditdata?.property_name,
          storeNumber: propertyEditdata?.store,
          propertyType: propertyEditdata?.property_type?.id,
          streetAddress: propertyEditdata?.street_address,
          city: propertyEditdata?.city,
          state: propertyEditdata?.state,
          zipcode: propertyEditdata?.zipcode,
          googleMapsLink: propertyEditdata?.google_map_link,
          rprLink: propertyEditdata?.rpr_link,
          lastUpdateDate: propertyEditdata?.updated_at ? new Date(Date.parse(propertyEditdata?.updated_at)) : "",
          comment: propertyEditdata?.comment,
          leaseType: propertyEditdata?.lease_type,
          leaseCommencementDate: propertyEditdata?.lease_commencement_date ? new Date(propertyEditdata?.lease_commencement_date) : "",
          leaseExpirationDate: propertyEditdata?.lease_expiration_date ? new Date(propertyEditdata?.lease_expiration_date) : "",
          annualRent: propertyEditdata?.anual_rent,
          askingCapRate: propertyEditdata?.asking_cap_rate,
          askingPrice: propertyEditdata?.asking_price,
          buildingSize: propertyEditdata?.building_size,
          landSize: propertyEditdata?.land_size,
          availabilityStatusUpdateDate: propertyEditdata?.availability_status_date ? new Date(propertyEditdata?.availability_status_date) : "",
          owner_name: propertyEditdata?.owner?.name,
          owner_id: propertyEditdata?.owner?.id,
          ownerType: propertyEditdata?.owner_info_type,
          guarantor_options: propertyEditdata?.guarantor_options,
          year_built: propertyEditdata?.year_built,
          year_renovated: propertyEditdata?.year_renovated,
          propertyTag: propertyEditdata?.propertytag_id,
        });
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching property details:", error); 
        if (error.response?.data?.message) {
          NotificationManager.error(error.response?.data?.message);
        }
        setLoading(false); 
      });
  };


  useEffect(() => {
    propertydetailsdata();
  }, [id]);

  const handleSubmit = (e) => {
    console.log(propertyInfo, "properttinfooo");

    e.preventDefault();

    const payload = {
      property_name: propertyInfo.propertyName,
      store: propertyInfo.storeNumber,
      property_type: propertyInfo?.propertyType,
      street_address: propertyInfo.streetAddress,
      city: propertyInfo.city,
      comment: propertyInfo.comment,
      state: propertyInfo.state,
      zipcode: propertyInfo.zipcode,
      google_map_link: propertyInfo.googleMapsLink,
      rpr_link: propertyInfo.rprLink,
      last_updated_date: propertyInfo.lastUpdateDate ? new Date(propertyInfo.lastUpdateDate).toISOString() : null,// Ensure ISO format
      lease_type: propertyInfo?.leaseType,
      lease_commencement_date: propertyInfo.leaseCommencementDate ? moment(propertyInfo.leaseCommencementDate).format('YYYY-MM-DD') : null, // Format the date
      lease_expiration_date: propertyInfo.leaseExpirationDate ? moment(propertyInfo.leaseExpirationDate).format('YYYY-MM-DD') : null, // Format the date
      anual_rent: propertyInfo.annualRent,
      asking_cap_rate: propertyInfo.askingCapRate,
      asking_price: propertyInfo.askingPrice,
      building_size: propertyInfo.buildingSize,
      guarantor_options: propertyInfo?.guarantor_options,
      year_built: propertyInfo?.year_built,
      year_renovated: propertyInfo?.year_renovated,
      land_size: propertyInfo.landSize,
      availability_status_date: propertyInfo.availabilityStatusUpdateDate ? moment(propertyInfo.availabilityStatusUpdateDate).format('YYYY-MM-DD') : null, // Format the date
      owner_info_type: propertyInfo?.ownerType,
      propertytag_id: propertyInfo?.propertyTag,
      owner: { name: propertyInfo?.owner_name, id: propertyInfo?.owner_id }
    };

    if (propertyInfo?.ownerType === "contact") {
      payload.owner_contact_id = propertyInfo?.owner_id;
    } else if  (propertyInfo?.ownerType === "company") {
      payload.owner_company_id = propertyInfo?.owner_id;
    }else{
        payload.owner_company_id = '';
        payload.owner_contact_id = '';
    }

    console.log(payload, "payloaddd")

    axios
      .post(`${BASE_URL}/property-edit/${id}`, payload, config)
      .then((res) => {
        console.log(res,"response in edit proeprty");
        
        setPropertyInfo(initialPropertyInfo);
        navigate(ROUTES.PROPERTY_DETAILS.replace(":id", id));
        if (res?.data?.message) {
          NotificationManager.success(res?.data?.message);
        }
      })
      .catch((error) => {
        setError(error.response?.data?.errors);
        if (error.response?.data?.message) {
          NotificationManager.error(error.response?.data?.message);
        }
      });
  };

  const clearError = (name) => {
    setError({ ...error, [name]: "" });
  };

  const handleClose = () => {
    setPropertyInfo(initialPropertyInfo);
    navigate(ROUTES.PROPERTY_DETAILS.replace(":id", id));
  };

  return (
    <BaseLayout>
      <div className="contact-header">
        <p className="head-1 dark-H md:px-0 px-3">Edit Property</p>
      </div>
      <div className="relative">
        {loading && (
          <div className="absolute inset-0 z-50 flex justify-center items-center bg-white/40 backdrop-blur-[1px]">
            <Loader />
          </div>
        )}
        <AddPropertyData
          from="edit"
          error={error}
          propertyInfo={propertyInfo}
          onSetFormData={(value) => {
            setPropertyInfo(value);
          }}
          handleSubmit={handleSubmit}
          handleClose={handleClose}
          clearError={clearError}
        />
      </div>
    </BaseLayout>
  );
};

export default EditProperty;
